import { StringInputControl } from '../../../../../types/types';
import Input, { InputType } from '../../../../Input/Input';
import { useTranslate } from '../../../../../hooks/context/useTranslate';
import { validateTextInput } from '../../../../../utils/managerUtils';
import type { GridInputBaseProps } from '../../types';
import { resolveDecorator } from '../../utils/resolveDecorator';

type StringInputProps = Omit<GridInputBaseProps, 'isColumnFilter'> & {
  control?: StringInputControl;
  type: InputType;
};

const StringInput = ({
  name,
  onChange,
  onTouch,
  onFocusIn,
  onFocusOut,
  value,
  error,
  setError,
  disabled,
  control,
  type,
}: StringInputProps) => {
  const { t } = useTranslate();
  const resolvedDecorator = resolveDecorator(control?.decorator);

  const onInputChange = (value: string): void => {
    onChange(value);
    onTouch?.(value);
    setError(null);
  };

  const onInputBlur = (): void => {
    if (value) {
      const textError = validateTextInput(
        value,
        control as StringInputControl,
        t
      );
      if (textError) {
        setError(textError);
      }
    }
    onFocusOut?.();
  };

  return (
    <Input
      className="string-filter-input"
      name={name}
      type={type}
      value={value === null ? '' : value}
      onChange={onInputChange}
      disabled={disabled}
      error={error}
      onBlur={onInputBlur}
      onFocus={onFocusIn}
      decorator={resolvedDecorator}
      // 'new-password' marks change-password fields as not-a-login, so Firefox's
      // password manager (which ignores 'off' on password fields) does not
      // autofill the saved app credentials here (heslo + username into menu search).
      autoComplete={type === 'password' ? 'new-password' : 'off'}
    />
  );
};

export default StringInput;
